function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 79,
  height: 79
}, React.createElement("rect", {
  width: 79,
  height: 79,
  fill: "#C4C4C4"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("path", {
  d: "M27.7534 42.9166L14.0197 33.3658L0 42.883L13.9879 52.4599L27.7534 42.9166Z",
  fill: "#0897FE"
}), React.createElement("path", {
  d: "M19.7848 12.9876L19.7635 28.2331L37.1567 40.3097L48.1298 32.714L19.7848 12.9876Z",
  fill: "#0D2CCC"
}), React.createElement("path", {
  d: "M19.7237 57.4316L19.7029 72.6801L50.3178 51.5341L50.3391 36.2864L19.7237 57.4316Z",
  fill: "#0D2CCC"
}), React.createElement("g", {
  opacity: 0.5,
  className: "path-2"
}, React.createElement("path", {
  opacity: 0.5,
  d: "M48.6886 12.6401L48.6678 27.8856L66.0609 39.9622L77.0336 32.3665L48.6886 12.6401Z",
  fill: "#0D2CCC"
}), React.createElement("path", {
  opacity: 0.5,
  d: "M48.6272 57.084L48.6059 72.3325L79.2213 51.1869L79.2421 35.9388L48.6272 57.084Z",
  fill: "#0D2CCC"
})));

var SvgFastIcon = function SvgFastIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFastIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FastIcon.135389a1.svg";
export { ForwardRef as ReactComponent };